import { render, staticRenderFns } from "./diffAllocDaily.vue?vue&type=template&id=c834a2bc&scoped=true&"
import script from "./diffAllocDaily.vue?vue&type=script&lang=js&"
export * from "./diffAllocDaily.vue?vue&type=script&lang=js&"
import style0 from "./diffAllocDaily.vue?vue&type=style&index=0&id=c834a2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c834a2bc",
  null
  
)

export default component.exports